/**
 * Go to a URL by creating a link and clicking it.
 */

export default (url) => {
    const anchorEl = document.createElement("a");
    anchorEl.href = url;
    anchorEl.click();
    anchorEl.remove();
}